import { ChangeEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';



const LanguageSwitcher = () => {
  const { i18n } = useTranslation( 'translation', { useSuspense: false } );

  const handleLanguageChange = ( e: SelectChangeEvent ) => {
    const newLang = e.target.value;
    i18n.changeLanguage( newLang );
    window.location.reload();
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleLanguageChange}
      size='small'
      className='translated'
      sx={{
        verticalAlign: 'sub',
        '& .MuiSelect-select': {
          paddingBottom: '2px',
          paddingTop: '2px',
        },
      }}
    >
      <MenuItem className='translated' value='en'>English        </MenuItem>
      <MenuItem className='translated' value='es-US'>Español (US)</MenuItem>
      <MenuItem className='translated' value='es-MX'>Español (MX)</MenuItem>
      <MenuItem className='translated' value='vi-VN'>Tiếng Việt     </MenuItem>
      <MenuItem className='translated' value='zh-Hans'>简体中文  </MenuItem>
      <MenuItem className='translated' value='zh-Hans-HK'>繁體中文 (HK)</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;
